import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = {
  key: 0,
  scope: "col"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex align-items-center gap-1" }
const _hoisted_12 = {
  class: "badge bg-secondary-subtle text-secondary fs-12 px-2 py-1",
  style: {"min-width":"28px","text-align":"center"}
}
const _hoisted_13 = {
  key: 0,
  class: "btn-group btn-group-sm ms-1",
  role: "group"
}
const _hoisted_14 = ["disabled", "onClick", "title"]
const _hoisted_15 = ["disabled", "onClick", "title"]
const _hoisted_16 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_17 = { class: "text-body" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 1,
  class: "badge bg-primary bg-opacity-15 text-primary d-inline-flex align-items-center gap-1"
}
const _hoisted_21 = {
  key: 1,
  class: "badge bg-light text-muted"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "d-flex align-items-center gap-1" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Packages",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search packages...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
          ], 32),
          (_ctx.isSuperAdmin)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: "/packages/create",
                class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                    _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                    _createElementVNode("span", null, "Add New Package")
                  ], -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "col" }, "ID", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("th", {
                    scope: "col",
                    style: {"width":"120px"}
                  }, "Urutan", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "col" }, "Package Name", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "col" }, "Price", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("th", { scope: "col" }, "Status", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("th", { scope: "col" }, "Akses / Mitra", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("th", { scope: "col" }, "Services", -1)),
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Actions"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[11] || (_cache[11] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.filteredPackages.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _cache[12] || (_cache[12] = [
                        _createElementVNode("td", {
                          colspan: "8",
                          class: "text-center py-4"
                        }, "No packages found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredPackages, (pkg, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: pkg.package_id
                        }, [
                          _createElementVNode("td", null, "#" + _toDisplayString(pkg.package_id), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(pkg.sort_order ?? 0), 1),
                              (_ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-light border p-0 d-flex align-items-center justify-content-center",
                                      style: {"width":"22px","height":"22px"},
                                      disabled: index === 0 || _ctx.isReordering || _ctx.searchQuery !== '',
                                      onClick: ($event: any) => (_ctx.movePackage(index, 'up')),
                                      title: _ctx.searchQuery ? 'Hapus pencarian untuk mengubah urutan' : 'Geser ke Atas'
                                    }, _cache[13] || (_cache[13] = [
                                      _createElementVNode("i", { class: "material-symbols-outlined fs-15" }, "arrow_upward", -1)
                                    ]), 8, _hoisted_14),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-light border p-0 d-flex align-items-center justify-content-center",
                                      style: {"width":"22px","height":"22px"},
                                      disabled: index === _ctx.filteredPackages.length - 1 || _ctx.isReordering || _ctx.searchQuery !== '',
                                      onClick: ($event: any) => (_ctx.movePackage(index, 'down')),
                                      title: _ctx.searchQuery ? 'Hapus pencarian untuk mengubah urutan' : 'Geser ke Bawah'
                                    }, _cache[14] || (_cache[14] = [
                                      _createElementVNode("i", { class: "material-symbols-outlined fs-15" }, "arrow_downward", -1)
                                    ]), 8, _hoisted_15)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("h6", _hoisted_16, _toDisplayString(pkg.package_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_17, "Rp " + _toDisplayString(Number(pkg.price).toLocaleString('id-ID')), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", pkg.is_active ? 'bg-success text-success' : 'bg-danger text-danger'])
                            }, _toDisplayString(pkg.is_active ? 'Active' : 'Inactive'), 3)
                          ]),
                          _createElementVNode("td", null, [
                            (pkg.is_campus_exclusive)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                  (pkg.partners && pkg.partners.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "badge bg-warning bg-opacity-20 text-warning-emphasis d-inline-flex align-items-center gap-1",
                                        title: pkg.partners.map((p) => p.name).join(', ')
                                      }, [
                                        _cache[15] || (_cache[15] = _createElementVNode("i", { class: "material-symbols-outlined fs-14" }, "school", -1)),
                                        _createElementVNode("span", null, _toDisplayString(pkg.partners.length === 1 ? pkg.partners[0].name : pkg.partners.length + ' Kampus Mitra'), 1)
                                      ], 8, _hoisted_19))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "material-symbols-outlined fs-14" }, "verified", -1),
                                        _createElementVNode("span", null, "Semua Kampus Mitra", -1)
                                      ])))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, " Umum "))
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pkg.services, (srv) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: srv.service_id,
                                class: "badge bg-secondary me-1"
                              }, _toDisplayString(srv.service_name), 1))
                            }), 128))
                          ]),
                          (_ctx.isSuperAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_RouterLink, {
                                    to: `/packages/${pkg.package_id}/edit`,
                                    class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                  }, {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.deletePackage(pkg.package_id)),
                                    class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                  }, _cache[18] || (_cache[18] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                                  ]), 8, _hoisted_24)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}